import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    products: [],
    productCategories: [],
    loaded: false,
    productModelDef: {
        id: null,
        categoryId: null,
        deliveryId: null,
        status: 1,
        offerId: null,
        article: null,
        title: '',
        description: '',
        weight: null,
        volume: null,
        diameter: null,
        size: null,
        color: null,
        price: 0,
        oldPrice: null,
        picture: null,
        stockQuantity: 0,
        createdAt: null,
        updatedAt: null
    },
}
export default {
    state,
    getters,
    actions,
    mutations
}
